export default {
  API_UNKNOWN: "The server experienced an unknown error."
}
